/* eslint-disable react/display-name */
import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { User } from '../../utils/types/Users';
import ToolManager from './ToolManager';
import CreateTool from './CreateTool';

export type ToolStackParamList = {
	Main: undefined;
	Create: { toolId: string };
};

const Stack = createStackNavigator<ToolStackParamList>();

interface ToolStackProps {
	user: User;
}

export default function ToolStack(): JSX.Element {
	return (
		<Stack.Navigator>
			<Stack.Screen
				name="Main"
				component={ToolManager}
				options={{
					headerShown: false,
				}}
			/>
			<Stack.Screen
				name="Create"
				component={CreateTool}
				options={{
					headerShown: false,
				}}
			/>
		</Stack.Navigator>
	);
}
